<template>
  <!--
          作者 gmshop
          时间：2019-10-26
          描述：设置-物流公司
      -->
  <div class="user">
    <div class="common-form">物流公司列表</div>
    <!--添加等级-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" v-auth="'/setting/express/add'">添加</el-button>
      <el-button type="primary" size="small" icon="el-icon-plus" v-if="show_wanliniu" @click="synWanliniu">同步快递公司</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="express_id" label="物流公司ID"></el-table-column>
          <el-table-column prop="express_name" label="物流公司名称"></el-table-column>
          <el-table-column prop="express_code" label="物流公司代码(快递100平台)"></el-table-column>
          <el-table-column prop="kdniao_express_code" label="物流公司代码(快递鸟平台)"></el-table-column>
          <el-table-column prop="kdzs_express_code" label="物流公司代码(快递助手)"></el-table-column>
		      <el-table-column prop="weixin_express_code" v-if="show_wechat" label="物流公司代码(微信平台)"></el-table-column>
		      <el-table-column prop="logistics_type" v-if="show_wdt" label="物流公司代码(旺店通ERP)"></el-table-column>
          <el-table-column prop="jushuitan_code" v-if="show_jst" label="物流公司代码(聚水潭erp平台)"></el-table-column>
          <el-table-column prop="wanliniu_distr_code" v-if="show_wanliniu" label="快递编码(万里牛erp平台)"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/setting/express/edit'" >编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small"  v-auth="'/setting/express/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import SettingApi from '@/api/setting.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user: '',
          region: ''
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        show_wechat: false,
        show_wdt: false,
        show_jst: false,
        show_wanliniu: false,
        /*当前编辑的对象*/
        userModel: {},
      };
    },
    created() {

      /*获取列表*/
      this.getData();
      if(this.$filter.isAuth('/appsetting/appwx/index')) this.show_wechat = true;
      if(this.$filter.isAuth('/setting/wangdiantong/index')) this.show_wdt = true;
      if(this.$filter.isAuth('/setting/jushuitan/index')) this.show_jst = true;
      if(this.$filter.isAuth('/setting/wanliniu/index')) this.show_wanliniu = true;

    },
    methods: {
      /*直播同步*/
      synWanliniu() {
        let self = this;
        self.loading = true;
        SettingApi.synWanliniuExpress({}, true)
          .then(res => {
            self.loading = false;
            self.getData()
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        SettingApi.expressList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {

          });
      },
      /*打开添加*/
      addClick() {
        this.$router.push('/setting/express/add');
      },

      /*打开编辑*/
      editClick(item) {
        let self = this;
        this.$router.push({
          path: '/setting/express/edit',
          query: {
            express_id: item.express_id
          }
        })
      },


      /*删除用户*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          SettingApi.deleteExpress({
              express_id: row.express_id
            }, true).then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();

            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {});
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setting/express/index.vue